/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import uuid from "react-uuid";

import {
  failureAction,
  onEntryAction,
  onErrorAction,
  onExitAction,
  resetAction,
  successAction,
  VappMachineConfig,
} from "../../../StateMachineService";
import {
  getCollectionListFromServer,
  formatCollectionChildren,
} from "./states";

const GET_COLLECTION_LIST_CONFIG: VappMachineConfig = {
  id: "services.PotfolioListPageService.machines.GetCollectionListConfig",
  initial: "IDLE",
  predictableActionArguments: true,
  context: {},
  states: {
    IDLE: {
      on: {
        START: {
          target: "GET_COLLECTION_LIST_FROM_SERVER",
          actions: [successAction],
        },
      },
    },
    GET_COLLECTION_LIST_FROM_SERVER: {
      entry: [onEntryAction],
      exit: [onExitAction],
      invoke: {
        id: "getCollectionListFromServer",
        src: getCollectionListFromServer,
        onDone: {
          target: "FORMAT_COLLECTION_CHILDREN",
          actions: [successAction],
        },
        onError: {
          target: "ERROR",
          actions: [failureAction],
        },
      },
    },
    FORMAT_COLLECTION_CHILDREN: {
      entry: [onEntryAction],
      exit: [onExitAction],
      invoke: {
        id: "formatCollectionChildren",
        src: formatCollectionChildren,
        onDone: {
          target: "END",
          actions: [successAction],
        },
        onError: {
          target: "ERROR",
          actions: [failureAction],
        },
      },
    },
    END: {
      type: "final",
    },
    ERROR: {
      type: "final",
    },
  },
  extendContextWith: function (extContext: any) {
    //@ts-ignore
    this.id = uuid();
    this.context = { ...this.context, ...extContext };
    return this;
  },
};
export { GET_COLLECTION_LIST_CONFIG };
